<template>
  <div>
    <v-text-field
      v-model="formData.kv"
      label="KV"
      outlined
      clearable
      dense
      autofocus
      @keydown.enter="fetchRekap"
    ></v-text-field>

    <h3>Preview</h3>
    <!-- <p v-if="state.noData">No Data</p> -->

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <div class="header">
        <div class="left">
          <h2 class="report-title">REKAP NOTA PER KAPAL</h2>
          <h3 class="text-center">
            {{ data.vessel.nama_kapal }} - {{ data.vessel.id }}
          </h3>
        </div>
        <div class="right ml-5">
          <table>
            <tr>
              <td>Tanggal Berangkat</td>
              <td>:</td>
              <td class="border">
                {{ convertTanggal(data.vessel.tgl_berangkat) }}
              </td>
            </tr>
            <tr>
              <td>Voyage</td>
              <td>:</td>
              <td class="border-dotted">{{ data.vessel.voy }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="mt-4">
        <div v-for="kode_nota in data.items" :key="kode_nota">
          <h2>Kode Nota: {{ kode_nota.kode_nota }}</h2>
          <p>Total: {{ kode_nota.items.length }}</p>

          <div
            v-for="penagih in kode_nota.items"
            :key="penagih.info.id"
            class="mb-4"
          >
            <h3>{{ penagih.info.nama_lengkap }}</h3>

            <table width="100%">
              <thead>
                <th>No Nota</th>
                <th>Customer</th>
                <th>Kubikasi</th>
                <th>Tonase</th>
                <th>Biaya Tambahan</th>
                <th>Total Invoice</th>
              </thead>
              <tbody>
                <tr v-for="item in penagih.items" :key="item.id">
                  <td class="text-center">{{ item.nomor_nota }}</td>
                  <td class="text-center"></td>
                  <td class="text-center">
                    {{ total_kubikasi(item.invoice_detil) }}
                  </td>
                  <td class="text-center">
                    {{ total_tonase(item.invoice_detil) }}
                  </td>
                  <td class="text-center">
                    {{ formatCurrency(item.biaya_lain_total) }}
                  </td>
                  <td class="text-center">
                    {{
                      formatCurrency(
                        Math.abs(item.i_total) +
                          Math.abs(item.ii_total) +
                          Math.abs(item.biaya_lain_total)
                      )
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>

    <!-- Print Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      v-if="!state.noData && !state.loading && data.vessel"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      state: {
        loading: false,
        noData: true
      },
      formData: {
        kv: ""
      },
      data: {},
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  computed: {
    today() {
      let date = new Date();
      let day = date.getDay();
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${this.days[day]}, ${date.getDate()} ${
        this.months[month]
      } ${year}`;
    }
  },
  methods: {
    printDocument() {
      window.print();
    },
    async fetchRekap() {
      this.state.loading = true;

      await axios
        .get(`invoice/rekap-nota?kv=${this.formData.kv}`)
        .then(res => {
          // console.log(res.data);
          if (res.data.length == 0) {
            this.state.noData = true;
          } else {
            this.data = res.data;
            this.state.noData = false;
          }
          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    },
    total_koli(data) {
      let total = 0;

      data.forEach(invoice => {
        invoice.ttb.ttb_rinci.forEach(rinci => {
          total += parseInt(rinci.koli);
        });
      });

      return total;
    },
    total_kubikasi(data) {
      let total = 0;

      data.forEach(invoice => {
        invoice.ttb.ttb_rinci.forEach(rinci => {
          total += rinci.m3;
        });
      });

      return total.toFixed(2);
    },
    total_tonase(data) {
      let total = 0;

      data.forEach(invoice => {
        invoice.ttb.ttb_rinci.forEach(rinci => {
          total += rinci.ton;
        });
      });

      return total.toFixed(2);
    },
    convertTanggal(data) {
      let date = new Date(data);
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${date.getDate()} ${this.months[month]} ${year}`;
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    }
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.header {
  display: flex;
}

.left .report-title {
  text-decoration: underline;
}

.right {
  font-style: italic;
  font-weight: bold;
  font-size: 1.1rem;
}
</style>
